module.exports = __webpack_public_path__ + "static/media/bg-prescriber-hero-01.32e6704f.jpg";